import { DEFAULT } from '../../mocks/trading-quantities.data';
import { ICcypair } from '@alk/currency';
import { inject, injectable } from 'inversify';
import { IStateManagerService, ITradingQuantities } from '../../interfaces';
import { ITradingQuantitiesService } from './trading-quantities.interface';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { SESSION_STATE_SERVICE } from '../session-state';

@injectable()
export class TradingQuantitiesService implements ITradingQuantitiesService {

    @inject(SESSION_STATE_SERVICE) private readonly sessionStateSrv: IStateManagerService;

    get(symbol: ICcypair): Observable<Array<number>> {
        return this.sessionStateSrv.stateObservable('tradingQuantities')
            .pipe(
                map((data: ITradingQuantities) => {
                    return data?.[ symbol ]?.values || data?.default?.values || DEFAULT;
                }),
            );
    }
}
